import { render, staticRenderFns } from "./PDFViewerHeader.vue?vue&type=template&id=3643fd1a"
import script from "./PDFViewerHeader.vue?vue&type=script&lang=js"
export * from "./PDFViewerHeader.vue?vue&type=script&lang=js"
import style0 from "./PDFViewerHeader.vue?vue&type=style&index=0&id=3643fd1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports